export enum NoticeType {
  FORM_FILLED = 'FORM_FILLED',
  EXTERNAL_TASK = 'EXTERNAL_TASK',
  SUB_TASK = 'SUB_TASK',
  BEHIND_SCHEDULE = 'BEHIND_SCHEDULE',
  OLD_STATUS = 'OLD_STATUS',
  FORM_DISCREPANCY = 'FORM_DISCREPANCY',
  NOTE_REMINDER = 'NOTE_REMINDER',
  SOS = 'SOS',
  TRIP_SHEET_FILLED = 'TRIP_SHEET_FILLED',
  EXPENSE_SHEET_FILLED = 'EXPENSE_SHEET_FILLED',
  VIOLATION = 'VIOLATION',
  VIN_UNVERIFIED = 'VIN_UNVERIFIED',
  DOCUMENT_UNVERIFIED = 'DOCUMENT_UNVERIFIED',
  ORDER_CREATED = 'ORDER_CREATED',
  ORDER_UPDATED = 'ORDER_UPDATED',
  ORDER_DELETED = 'ORDER_DELETED',
  REPLAN_SUGGESTION = 'REPLAN_SUGGESTION',
  FUELLING_REPLANNED = 'FUELLING_REPLANNED',
  TUNNEL_RESERVED = 'TUNNEL_RESERVED',
  FAILED_TUNNEL_RESERVATION = 'FAILED_TUNNEL_RESERVATION',
  FUEL_LIMIT_THRESHOLD_REACHED = 'FUEL_LIMIT_THRESHOLD_REACHED',
  CLIENT_FUEL_LIMIT_REACHED = 'CLIENT_FUEL_LIMIT_REACHED',
  UNREACHABLE_STATION = 'UNREACHABLE_STATION',
  NO_STATIONS_FOUND = 'NO_STATIONS_FOUND',
  PARKING_NOT_PLANNED = 'PARKING_NOT_PLANNED',
  NO_PARKINGS_FOUND = 'NO_PARKINGS_FOUND',
  REPAIR_ORDER_CREATED = 'REPAIR_ORDER_CREATED',
  ISSUE_STATUS_CHANGED = 'ISSUE_STATUS_CHANGED',
  REPAIR_ORDER_STATUS_CHANGED = 'REPAIR_ORDER_STATUS_CHANGED',
  REPAIR_ORDER_TOP_PRIORITY_CREATED = 'REPAIR_ORDER_TOP_PRIORITY_CREATED',
  ISSUE_DRIVER_CHAT_NEW_ENTRY = 'ISSUE_DRIVER_CHAT_NEW_ENTRY',
  SERVICE_CANDIDATES_PENDING_MANAGER = 'SERVICE_CANDIDATES_PENDING_MANAGER',
  SERVICE_PRELIMINARY_SELECTED = 'SERVICE_PRELIMINARY_SELECTED',
  SERVICE_DRAFT_TASK_TO_CONFIRM = 'SERVICE_DRAFT_TASK_TO_CONFIRM',
  REPAIR_ORDER_CUSTOM_REMINDER = 'REPAIR_ORDER_CUSTOM_REMINDER',
  TRAFFIC_BAN = 'TRAFFIC_BAN'
}
